import NoBooking from "../../Components/NoBooking/NoBooking";
import ProfileNavbar from "../../Components/ProfileNavbar/ProfileNavbar";

export default function NoBookingPage() {

  return (
    <>
        <ProfileNavbar/>
        <NoBooking/>
    </>
  );
}
